export const primitiveShadows = {
	light: {
		sm: '0px 1px 2px rgba(0, 0, 0, 0.05)',
		md: '8px 14px 21px rgba(163, 172, 181, 0.23)',
		lg: '1px 33px 20px rgba(166, 176, 185, 0.0920837)',
		xl: '-1px -33px 20px rgba(166, 176, 185, 0.0920837), 0px 50px 64px rgba(186, 194, 202, 0.4)',
		'2xl': '1px 50px 64px rgba(24, 29, 79, 0.15), -1px -2px 20px rgba(24, 29, 79, 0.1)',
	},
	dark: {
		sm: '0px 1px 2px rgba(19, 20, 21, 0.12)',
		md: '8px 14px 21px rgba(19, 20, 21, 0.35)',
		lg: '1px 33px 20px rgba(19, 20, 21, 0.1)',
		xl: '-1px -33px 20px rgba(19, 20, 21, 0.1), 0px 50px 64px rgba(19, 20, 21, 0.25)',
		'2xl': '1px 50px 64px rgba(19, 20, 21, 0.5), -1px -2px 20px rgba(19, 20, 21, 0.6)',
	},
} as const;

export const boxShadow = {
	small: primitiveShadows.light.sm,
	normal: primitiveShadows.light.md,
	middle: primitiveShadows.light.lg,
	long: primitiveShadows.light.xl,
	extreme: primitiveShadows.light['2xl'],
} as const;
